import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=60f83d25&scoped=true"
import script from "./settings.vue?vue&type=script&lang=js"
export * from "./settings.vue?vue&type=script&lang=js"
import style0 from "./settings.vue?vue&type=style&index=0&id=60f83d25&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f83d25",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/subsapp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60f83d25')) {
      api.createRecord('60f83d25', component.options)
    } else {
      api.reload('60f83d25', component.options)
    }
    module.hot.accept("./settings.vue?vue&type=template&id=60f83d25&scoped=true", function () {
      api.rerender('60f83d25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/settings/settings.vue"
export default component.exports